import { AppSettings } from '../../proyect.conf';

export type NivelLog = 'INFO' | 'ERROR' | 'OFF';

function obtenerNivelConfigurado(): NivelLog {
  const nivelStr = (AppSettings.loggingLevel || 'INFO').toUpperCase();
  if (nivelStr === 'ERROR' || nivelStr === 'OFF') {
    return nivelStr;
  }
  return 'INFO';
}

export function inicializarLogger(): void {
  try {
    const consoleObj = console;
    if (!consoleObj) return;

    const metodos = Object.keys(consoleObj)
      .filter(nombre => typeof (consoleObj as any)[nombre] === 'function');

    const originales: Record<string, (...args: any[]) => void> = {};
    metodos.forEach(metodo => {
      originales[metodo] = (consoleObj as any)[metodo].bind(consoleObj);
    });

    metodos.forEach(metodo => {
      (consoleObj as any)[metodo] = function(...args: any[]): void {
        const nivel = obtenerNivelConfigurado();
        if (nivel === 'OFF') return;
        if (nivel === 'ERROR' && metodo !== 'error') return;
        originales[metodo].apply(consoleObj, args);
      };
    });

  } catch (error) {
    if (console && console.warn) {
      console.warn('No se pudo inicializar la intercepción de console: ', (error as Error).message);
    }
  }
}
